import React from "react";

/**
 * <BrandMark /> — a small monospace identity tag used in hero corners and
 * other "this is a real thing" moments. Recurring brand element.
 *
 *   001 / GCBC / EST · 2026
 */
export function BrandMark({ id = "001", className = "" }) {
  return (
    <div className={`font-mono text-[10px] uppercase tracking-[0.18em] text-ink-hint flex items-center gap-2 ${className}`} data-testid="brand-mark">
      <span className="text-brand-700">{id}</span>
      <span className="opacity-60">/</span>
      <span>GCBC</span>
      <span className="opacity-60">/</span>
      <span>EST · 2026</span>
    </div>
  );
}
